import type { SVGProps } from 'react';

const SvgInfoCircleFill = (props: SVGProps<SVGSVGElement>) => (
  <svg
    fill='none'
    height='1em'
    viewBox='0 0 32 32'
    width='1em'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <ellipse cx={16.948} cy={17.242} fill='#138FED' rx={4.167} ry={9.357} />
    <path
      d='M15.999 2.685c-7.364 0-13.334 5.97-13.334 13.334S8.635 29.352 16 29.352c7.363 0 13.333-5.97 13.333-13.333 0-7.364-5.97-13.334-13.333-13.334Zm0 6.667a1.334 1.334 0 1 1 0 2.667 1.334 1.334 0 0 1 0-2.667Zm0 4c.736 0 1.333.598 1.333 1.333v6.667a1.334 1.334 0 0 1-2.667 0v-6.667c0-.736.597-1.333 1.334-1.333Z'
      fill='#E8F3FF'
    />
  </svg>
);
export default SvgInfoCircleFill;
